import { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Sidebar from "../sidebar/Sidebar";
import { FormattedMessage } from "react-intl";

import Swal from "sweetalert2";

import "../../assets/styles/component/userManager.css";
import { getAccCtrl, registerAccCtrl } from "../../controllers/register.controller";
import { check_role } from "../../controllers/helps.controller";

const UserManage = () => {
  const [navstate, setNavstate] = useState(localStorage.getItem("nav-state") ?? true);

  if (!check_role("superadmin")) {
    window.location.replace("/404");
  }
  useEffect(() => {
    if (!localStorage.getItem("username-redeem")) {
      window.location.replace("/login");
    }
    if (localStorage.getItem("role-redeem") === "user") {
      window.location.replace("/404");
    }
    if (localStorage.getItem("role-redeem") === "admin") {
      document.querySelectorAll(".role-superadmin").forEach((el) => {
        el.classList.add("none-display");
      });
    }
  }, []);

  //Register Account
  useEffect(() => {
    document.getElementById("register-btn").addEventListener("click", () => {
      if (document.getElementById("register-btn").getAttribute("click-id") === "false") {
        document.getElementById("register-btn").setAttribute("click-id", "true");
        let username = document.getElementById("username-register").value;
        let pass = document.getElementById("pass-register").value;
        let role = document.getElementById("role-register").value;
        if (username === "" || pass === "" || role === "default") {
          Swal.fire(
            <FormattedMessage id="register.error.title" defaultMessage="Operation failed!" />,
            <FormattedMessage id="register.error.message" defaultMessage="Please fill in all the information." />,
            "error"
          );
        } else {
          Swal.fire({
            text: <FormattedMessage id="register.creating" defaultMessage="Creating account..." />,
            width: 250,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          registerAccCtrl(username.toLowerCase(), pass, role);
        }
      }
    });
  }, []);

  const handleShowPass = (e) => {
    e.target.classList.toggle("fa-eye-slash");
    e.target.classList.toggle("fa-eye");
    if (e.target.classList.contains("fa-eye-slash")) {
      document.getElementById("pass-register").setAttribute("type", "text");
    }
    if (e.target.classList.contains("fa-eye")) {
      document.getElementById("pass-register").setAttribute("type", "password");
    }
  };

  useEffect(() => {
    getAccCtrl();
  }, []);
  return (
    <>
      <Sidebar setNavstate={setNavstate} navstate={navstate} />
      <div id="main" className={navstate ? "" : "main-wide"}>
        <Header
          setNavstate={setNavstate}
          navstate={navstate}
          title={<FormattedMessage id="userManage.header.title" defaultMessage="Account Management" />}
        />
        <div className="body-user-manage">
          <div className="register-cont">
            <div className="title-register-table title-find-code-table">
              <div className="mark"></div>
              <p className="title-text-table">
                <FormattedMessage id="register.form.title" defaultMessage="Create Account" />
              </p>
            </div>
            <div className="register-form-cont">
              <div className="input-form-wrapper">
                <div className="row-input">
                  <input
                    id="username-register"
                    type="text"
                    placeholder={<FormattedMessage id="register.username.placeholder" defaultMessage="Username" />}
                    autoComplete="off"
                  />
                </div>
                <div className="row-input row-register">
                  <input
                    id="pass-register"
                    type="password"
                    placeholder={<FormattedMessage id="register.password.placeholder" defaultMessage="Password" />}
                    autoComplete="off"
                  />
                  <i className="toggle-pass-regis fa-regular fa-eye" onClick={handleShowPass}></i>
                </div>
                <div className="type">
                  <div className="row-input">
                    <select id="role-register">
                      <option value="default">
                        <FormattedMessage id="register.role.default" defaultMessage="- Select Role -" />
                      </option>
                      <option className="role-superadmin" value="superadmin">
                        <FormattedMessage id="register.role.superadmin" defaultMessage="Super Admin" />
                      </option>
                      <option value="user">
                        <FormattedMessage id="register.role.user" defaultMessage="User" />
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  id="register-btn"
                  className="search-icon"
                  title={<FormattedMessage id="register.button.title" defaultMessage="Create Account" />}
                  click-id="false"
                >
                  <i className="fa-solid fa-user-plus"></i>
                  <FormattedMessage id="register.button.text" defaultMessage="Create Account" />
                </div>
              </div>
            </div>
          </div>
          <div className="list-user-cont">
            <div className="title-register-table title-find-code-table">
              <div className="mark"></div>
              <p className="title-text-table">
                <FormattedMessage id="userList.title" defaultMessage="User List" />
              </p>
            </div>
            <div className="find-list-user">
              <div className="row-title-find-user">
                <div className="title-user-list username-row">
                  <FormattedMessage id="userList.username" defaultMessage="Username" />
                </div>
                <div className="title-user-list role-row">
                  <FormattedMessage id="userList.role" defaultMessage="Role" />
                </div>
                <div className="title-user-list config-row">
                  <FormattedMessage id="userList.actions" defaultMessage="Actions" />
                </div>
              </div>
              <div id="body-find-user"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserManage;
